<template>
  <div>
    <fieldset class="fieldset">
      <p class="use-case-title my-5">
        What will you be using containers for?
      </p>    
      <div class="field">
        <div class="control radio-list flex flex-row 1170:flex-col  justify-between ">       
          <a 
            v-for="(label, value) in stepOptions" 
            :key="value" 
            @click="chooseCase(value)" 
            class="select-card bg-white is-flex is-flex-direction-column is-justify-content-center is-align-items-center is-size-7 1170:mb-4 mb-2 hover:shadow transition-all" 
            :class="updates.useCase == value ? 'active' : ''">
            <!--<input v-model="updates.useCase" type="radio" :value="value">-->          
              <icon :type="value" class="icon-svg" :class="updates.useCase == value ? 'icon-white' : ''" />
              <span class="mt-2 use-case-label">{{ label }}</span>
          </a>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { DynamicStep } from './mixin'
import Icon from './helpers/icon.vue'
export default {
  mixins: [ DynamicStep('useCase') ],
  components: {
    Icon
  },
  methods: {
    chooseCase(value) {
      this.updates.useCase = value
    }
  }
}
</script>

<style scoped>
.icon-white {
  filter: brightness(0) invert(1);
}
.icon-hover {
  filter: invert(34%) sepia(99%) saturate(6801%) hue-rotate(222deg) brightness(89%) contrast(101%);
}
.control.radio-list {
  flex-wrap: wrap;
}
</style>
